export default __webpack_public_path__ + "static/media/code_wes.6f6144ae.png";